import { TableConfig } from '@shared/interfaces/table/table-config';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import { statePartial } from '@shared/partials/state.partial';
import { ConnectionPointSearchResult } from '@app/api/nts';

export const connectionpointTable: TableConfig<ConnectionPointSearchResult> = {
  id: 'connectionpoint-list',
  title: 'connectionpoint.title',
  exportable: true,
  copyable: true,
  selectable: true,
  selectableType: 'single',
  floatingHeader: true,
  pageSize: 25,
  pageSizeSelection: true,
  columnSelection: true,
  saveChanges: true,
  columns: [
    {
      title: 'connectionpoint.identification',
      key: 'connectionPointIdentification',
      width: 175,
      cellRenderer: LinkCellComponent,
      cellRendererParams: {
        url: '/connectionpoint',
        urlReference: 'connectionPointIdentification',
      }
    },
    {
      title: 'connectionpoint.stationsNumber',
      key: 'stationNumber'
    },
    statePartial,
    {
      title: 'meter.meterNumber',
      key: 'meterNumber'
    },
    {
      title: 'meter.alternativeMeterNumber',
      key: 'alternativeMeterNumber'
    },
    {
      title: 'connectionpoint.connectionPointId',
      key: 'meteringPointIdentification'
    },
    {
      title: 'address.title',
      key: 'address'
    }
  ]
}
